import { BusinessUnitSelectors, CoreLocaleKeys, LogHelper, MetadataActions, MetadataConstants, MetadataSelectors, i18n } from 'invision-core';
import pathOr from 'ramda/src/pathOr';
import CustomerCareLocaleKeys from '../../../../locales/keys';
import { IsUpdatingAddressSelector, PostalCodeSelector, PreventOverrideFlagSelector, PreventRemovalOfDefaultTypesSelector, UpdateAddressErrorSelector, UpdateAddressPopupStateRegionProvinceValueOptions } from '../../../../reducers/selectors/customer.addresses.selectors';
import { setAddressData, updateAddress, updateFormAddress, updateOverrideFlag } from '../../../../reducers/actions/customer.addresses.actions';
import { ADDRESS_FORM_FIELD_MAX_LENGTH } from '../addresses.constants';
import { isAddressValidFromAddressResponse } from '../../../shared/contextualComponents/address/address.validator.helper';
import { IsValidatingStatusSelector, UnvalidatedAddressesSelector, ValidatedAddressesSelector } from '../../../../reducers/selectors/address.component.selectors';
import { setForceShowEditFormAddress, validateAddress } from '../../../../reducers/actions/address.component.actions';
import { invalidateCreditClassification } from '../../../../reducers/actions/customer.actions';
import { performCreditCheck } from '../../../../reducers/actions/credit.check.actions';
import { stateRequiredHelper } from './../address.helper';
function UpdateAddressPopupController($ngRedux, $timeout, uiNotificationService) {
  var _this = this;
  var popupApi = null;
  var mapStateToTarget = function mapStateToTarget(store) {
    return {
      addressCountriesLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.AddressCountry, store),
      addressStatesLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.AddressStateProvinceRegion, store),
      addressRequirements: MetadataSelectors.codes.MetadataCodeTypeSelector(MetadataConstants.codes.AddressRequirements, store),
      addressRequirementsLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.AddressRequirements, store),
      addressStatesOptions: UpdateAddressPopupStateRegionProvinceValueOptions(store),
      isAddressBeingValidatedFromApi: IsValidatingStatusSelector(store),
      isDbss: BusinessUnitSelectors.IsDbss(store),
      isUpdatingAddress: IsUpdatingAddressSelector(store),
      lastAttemptError: UpdateAddressErrorSelector(store),
      postalCode: PostalCodeSelector(store),
      preventOverrideFlag: PreventOverrideFlagSelector(store),
      preventRemovalOfDefaultTypes: PreventRemovalOfDefaultTypesSelector(store),
      unvalidatedAddresses: UnvalidatedAddressesSelector(store),
      validatedAddresses: ValidatedAddressesSelector(store)
    };
  };
  var controllerActions = {
    fetchAddressCountryTypes: MetadataActions.codes.fetchAddressCountryTypes,
    fetchAddressStateTypes: MetadataActions.codes.fetchAddressStateTypes,
    fetchCodeType: MetadataActions.codes.fetchCodeTypes,
    invalidateCreditClassification: invalidateCreditClassification,
    performCreditCheck: performCreditCheck,
    setAddressData: setAddressData,
    setForceShowEditFormAddress: setForceShowEditFormAddress,
    updateAddress: updateAddress,
    updateFormAddress: updateFormAddress,
    updateOverrideFlag: updateOverrideFlag,
    validateAddress: validateAddress
  };
  this.$onInit = function () {
    _this.resetForm();
    _this.showForm = false;
    _this.disconnectRedux = $ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
      _this.state = state;
      _this.actions = actions;
    });
    if (!_this.state.addressStatesLoaded) {
      _this.actions.fetchAddressStateTypes();
    }
    _this.formMaxLengthValidation = ADDRESS_FORM_FIELD_MAX_LENGTH;
    _this.CustomerCareLocaleKeys = CustomerCareLocaleKeys;
    _this.CoreLocaleKeys = CoreLocaleKeys;
    _this.onAddressFormChanged = _this.onAddressFormChanged.bind(_this);

    // hook the popupApi
    var onRegisterApi = _this.config.onRegisterApi;
    _this.config.onRegisterApi = function (_ref) {
      var api = _ref.api;
      popupApi = Object.assign({}, api, {
        open: function open() {
          _this.resetForm();
          _this.showForm = true;
          // NOTE: must wait for the ng-if bound to showForm to operate, for the popup centering logic
          $timeout(function () {
            api.open();
          });
        }
      });
      onRegisterApi && onRegisterApi({
        api: popupApi
      });
    };
    if (!_this.state.addressRequirementsLoaded) {
      _this.actions.fetchCodeType(MetadataConstants.codes.AddressRequirements);
    }
  };
  this.handleCloseDialog = function () {
    _this.closePopup();
  };
  this.handleKeypressForm = function (event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      _this.handleSubmitForm();
    }
  };
  this.handleSubmitForm = function () {
    _this.formController.$submitted = true;
    _this.formController.highlightErrorMessages();
    if (_this.formController.$valid) {
      _this.validateAddressWithAPI().then(function () {
        var addressKey = _this.getAddressKey();
        var validatedAddress = _this.state.validatedAddresses[addressKey];
        if (!addressKey || validatedAddress && isAddressValidFromAddressResponse(validatedAddress)) {
          _this.actions.updateAddress(_this.customerId, _this.formAddress, _this.textScrubberOverride, _this.state.preventOverrideFlag).then(function (result) {
            _this.closePopup();
            var onAddressUpdated = _this.onAddressUpdated();
            onAddressUpdated && onAddressUpdated(result.Address);
            _this.actions.performCreditCheck(null, _this.customerId);
            _this.actions.invalidateCreditClassification();
            _this.actions.updateOverrideFlag(null);
          });
        } else {
          _this.actions.setForceShowEditFormAddress(false);
          uiNotificationService.transientError(i18n.translate(_this.CustomerCareLocaleKeys.ADDRESS_COMPONENT.INVALID_ADDRESS_ERROR_MESSAGE));
        }
      }).catch(function (err) {
        uiNotificationService.transientError(err.translatedMessage);
      });
    }
  };
  this.handleClickCancelButton = function () {
    _this.closePopup();
  };
  this.handleChangeFormCountry = function () {
    _this.updateStateField();
  };
  this.closePopup = function () {
    if (_this.isUpdatingAddress) {
      // app is going to crash; log a User-friendly message for the developer
      LogHelper.debug('closing popup while awaiting async operation');
    }
    popupApi.close();
    _this.showForm = false;
  };
  this.resetForm = function () {
    _this.formAddress = Object.assign({}, _this.address);
    _this.addressFormModel = {
      shipToName: _this.address ? _this.address.ShipToName : null,
      addressLine1: _this.address ? _this.address.LineOne : null,
      addressLine2: _this.address ? _this.address.LineTwo : null,
      city: _this.address ? _this.address.City : null,
      country: _this.address ? _this.address.Country : null,
      stateRegionProvince: _this.address ? _this.address.State : null,
      postalCode: _this.address ? _this.address.PostalCode : null
    };
    _this.textScrubberOverride = undefined;
    // called before $ngRedux.connect, must guard
    _this.actions && _this.state && _this.updateStateField();
  };
  this.updateStateField = function () {
    _this.actions.setAddressData(_this.formAddress, _this.textScrubberOverride);
    _this.actions.updateFormAddress(_this.formAddress);
    _this.stateRequired = stateRequiredHelper(_this.state.addressRequirements, _this.state.addressStatesOptions);
    if (_this.state.addressStatesOptions && !_this.state.addressStatesOptions.find(function (stateOption) {
      return stateOption.value === _this.formAddress.State;
    })) {
      _this.formAddress.State = null;
      _this.addressFormModel.stateRegionProvince = _this.formAddress.State;
    }
  };
  this.validateAddressDefaults = function () {
    _this.actions.updateFormAddress(_this.formAddress);
  };
  this.showDescription = function () {
    var prevent = _this.state.preventRemovalOfDefaultTypes;
    return prevent.service || prevent.home || prevent.postal || prevent.work;
  };
  this.onAddressFormChanged = function (addressFormModel) {
    /*
        Check if the addressForm country field changed if
        then trigger handleChangeForm route
    */
    _this.formAddress.LineOne = addressFormModel.addressLine1;
    _this.formAddress.LineTwo = addressFormModel.addressLine2;
    _this.formAddress.City = addressFormModel.city;
    _this.formAddress.State = addressFormModel.stateRegionProvince;
    _this.formAddress.PostalCode = addressFormModel.postalCode ? addressFormModel.postalCode : null;
    _this.formAddress.ShipToName = addressFormModel.shipToName;
    Object.assign(_this.addressFormModel, addressFormModel);
    _this.addressFormModel.postalCode = addressFormModel.postalCode ? addressFormModel.postalCode : null;
    if (addressFormModel.country !== _this.formAddress.Country) {
      _this.formAddress.Country = addressFormModel.country;
      _this.handleChangeFormCountry();
    }
  };
  this.$onDestroy = function () {
    _this.disconnectRedux();
  };
  this.getAddressKey = function () {
    return pathOr(undefined, ['formController', 'addressWrapupController.singleAddressFormFormApi', 'addressKey'], _this);
  };
  this.getAddressKeyForAddressValidatedThroughAPI = function () {
    return pathOr(undefined, ['formController', 'addressWrapupController.singleAddressFormFormApi', 'keyForAddressValidatedThroughAPI'], _this);
  };
  this.getJobToken = function () {
    var addressKey = _this.getAddressKey(),
      addressKeyForAddressValidatedThroughAPI = _this.getAddressKeyForAddressValidatedThroughAPI(),
      validatedAddressForCurrentAddress = _this.state.validatedAddresses[addressKey],
      validatedAddressForAddressValidatedThroughAPI = _this.state.validatedAddresses[addressKeyForAddressValidatedThroughAPI];
    if (validatedAddressForCurrentAddress && validatedAddressForCurrentAddress.JobToken) {
      return validatedAddressForCurrentAddress.JobToken;
    } else if (validatedAddressForAddressValidatedThroughAPI && validatedAddressForAddressValidatedThroughAPI.JobToken) {
      return validatedAddressForAddressValidatedThroughAPI.JobToken;
    }
    return null;
  };
  this.validateAddressWithAPI = function () {
    var addressKey = _this.getAddressKey(),
      unvalidatedAddress = _this.state.unvalidatedAddresses[addressKey],
      validatedAddress = _this.state.validatedAddresses[addressKey];
    if (validatedAddress || !unvalidatedAddress) {
      return Promise.resolve(100);
    } else {
      var addressTypes = {
        DefaultBilling: _this.formAddress.DefaultBilling,
        DefaultHome: _this.formAddress.DefaultHome,
        DefaultPostal: _this.formAddress.DefaultPostal,
        DefaultService: _this.formAddress.DefaultService,
        DefaultShipping: _this.formAddress.DefaultShipping,
        DefaultWork: _this.formAddress.DefaultWork
      };
      return _this.actions.validateAddress(addressKey, unvalidatedAddress, _this.getJobToken(), addressTypes);
    }
  };
}
export default {
  template: require('./update.address.popup.html'),
  bindings: {
    address: '<',
    config: '<',
    customerId: '<',
    onAddressUpdated: '&',
    shipToNameRequired: '<'
  },
  controllerAs: 'UpdateAddressPopupController',
  controller: UpdateAddressPopupController
};